import { getToDay } from '@/utils/date';
import { message } from 'antd';
import { getDelayPage, delayExport } from '@/services/cost';
import moment from 'moment';

let [startDate, endDate] = getToDay();

export default {
  namespace: 'delayDetails',
  state: {
    searchParams: {
      startDate: moment(startDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD'),
      endDate: moment(endDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD'),
      delayStage: undefined, //['出发', '中转', '运输', '派送'],
      delayFlag: ['10'],
      mark: ['10', '20'],//中转属性
    },
    page: 1,
    pageSize: 20,
    endPage: 1,
    endPageSize: 20,
    onSearch: false,
    tableDatas: [],
    endTableDatas: [],
    exportVisible: false,
    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
    tabType: "line",

  },

  effects: {
    // 分页查询
    *getDatas({ payload }, { call, put, select }) {

      const delayDetails = yield select(({ delayDetails }) => delayDetails);
      if (payload.tabType === "line") {
        try {
          const obj = handler(delayDetails, "line");
          const result = yield call(getDelayPage, obj);

          if (result?.code === 1 && result?.data) {
            yield put({
              type: 'updateState',
              payload: {
                tableDatas: result?.data?.rows || [],
                total: result?.data?.total || 0,
              },
            });
          }
        } catch (err) {
          message.warn(err.message);
        }
      } else {
        try {
          const obj = handler(delayDetails, "end");
          const result = yield call(getDelayPage, obj);
          if (result?.code === 1 && result?.data) {

            yield put({
              type: 'updateState',
              payload: {
                endTableDatas: result?.data?.rows || [],
                endTotal: result?.data?.total || 0,
              },
            });
          }
        } catch (err) {
          message.warn(err.message);
        }
      }


    },
    // 按钮查询
    *searchDay(payload, { call, put, select }) {
      yield put({
        type: 'updateState',
        payload: { page: 1 },
      });
      const delayDetails = yield select(({ delayDetails }) => delayDetails);
      if (delayDetails.tabType === "line") {
        try {
          const obj = handler(delayDetails);

          const result = yield getDelayPage(obj);

          if (result?.code === 1 && result?.data) {
            yield put({
              type: 'updateState',
              payload: {
                tableDatas: result?.data?.rows || [],
                total: result?.data?.total || 0,
              },
            });
          } else {
            yield put({
              type: 'updateState',
              payload: {
                tableDatas: [],
                total: 0,
              },
            });
          }
        } catch (err) {
          message.warn(err.message);
        }
      } else {
        try {
          const obj = handler(delayDetails);
          const result = yield getDelayPage(obj);
          if (result?.code === 1 && result?.data) {
            yield put({
              type: 'updateState',
              payload: {
                endTableDatas: result?.data?.rows || [],
                endTotal: result?.data?.total || 0,
              },
            });
          } else {
            yield put({
              type: 'updateState',
              payload: {
                endTableDatas: [],
                endTotal: 0,
              },
            });
          }
        } catch (err) {
          message.warn(err.message);
        }
      }



    },

    *delayExport({ payload }, { call, put, select }) {
      const delayDetails = yield select(({ delayDetails }) => delayDetails);
      try {
        const obj = handler(delayDetails);

        const result = yield call(delayExport, { ...obj, ...payload });

        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },

    resetState(state) {
      return { state, tableDatas: [], offset: undefined };
    },
  },
};

const handler = (delayDetails, tabType) => {
  const { page, endPage, pageSize, endPageSize, searchParams } = delayDetails;
  const { dutyName, currentSiteCode, delayType, startDate, endDate, ...others } = searchParams;
  // console.log('dutyName', dutyName);
  // if (!access.isHead) {
  // if (dutyName) {
  //   if (dutyName.length === 0) {
  //     throw new Error('请选择出发组织');
  //   }
  // } else {
  //   throw new Error('请选择出发组织');
  // }
  // }
  console.log("筛选值", searchParams);
  let obj = {
    offset: page,
    limit: pageSize,
    startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
    endDate: moment(endDate).format('YYYY-MM-DD 00:00:00'),
    dutyName: dutyName?.code,
    currentSiteCode: currentSiteCode?.code,
    ...others,
    // mark:["10","20"]
  };
  if (!obj.mark || obj.mark.length === 0) {
    obj.mark = ["10", "20"]
  }
  if (delayDetails.tabType === "end") {
    obj = {
      offset: endPage,
      limit: endPageSize,
      startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
      endDate: moment(endDate).format('YYYY-MM-DD 00:00:00'),
      dutyName: dutyName?.code,
      currentSiteCode: currentSiteCode?.code,
      ...others,
      mark: ["30"]
    };
  }
  if (delayType && delayType.length > 0) {
    obj.delayType = delayType.join(',');
  }
  return obj;
};
